import { CoreIcon } from '../core-icon';
import checkCircleFillSVG from '../../../src/images/icons/check-circle-fill.svg';

export const CheckCircleFillIcon = props => {
  return <CoreIcon src={checkCircleFillSVG} {...props} />;
};
